// import isMobile from "../../plugins/is-mobile.js";
// if (isMobile(500)) {
//   // $('#topHeroVideoPc').get(0).play();
//   const target = document.querySelector("#topHeroVideo");
//   // target.setAttribute("src", target.getAttribute("src").replace("_pc", "_pc"));
//   // target.setAttribute("poster", target.getAttribute("poster").replace("-pc", "-sp"));
// }

// if ($('.page-top').length) {
//   console.log('TOP PAGE');

//   // $(window).on('load', function () {
//     console.log("loaded");
//     $('.page-top').addClass('is-loaded');



//     //  else {
//     //   $('#topHeroVideoSp').get(0).play();
//     // }
//     $('#topHeroVideo').get(0).play();
//   // });
// }

import isMobile from "../../plugins/is-mobile.js";

if (isMobile(500)) {
  // $('#topHeroVideoPc').get(0).play();
  const target = document.querySelector("#topHeroVideo");
  if (target) {
    // target.setAttribute("src", target.getAttribute("src").replace("_pc", "_pc"));
    // target.setAttribute("poster", target.getAttribute("poster").replace("-pc", "-sp"));
  }
}

if ($('.page-top').length) {
  console.log('TOP PAGE');

  // $(window).on('load', function () {
  console.log("loaded");
  $('.page-top').addClass('is-loaded');

  const topHeroVideo = $('#topHeroVideo').get(0);
  if (topHeroVideo) {
    topHeroVideo.play();
  }
  // });
}
